import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const XIXFreeverse = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - XIX FREEVERSE</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - XIX FREEVERSE</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                Kalam se meri hu Karigar mai<br/>
                Jabhi utru stage pe to lashe biche<br/>
                Dikhti jalan hai saaf mere se bete yahape tu aakhe milaake to dekh<br/>
                Kaam mera faila jo haali me ye mere naam pe kyu keechad uchaalne lage<br/>
                Lera mai shots, ghoda khaali kare<br/>
                Abhi sun ne me aati bas taarif<br/>
                <br/>
                Wo kehte they loser na jaane kyu par wo kabhi pohoch hi nai paye<br/>
                I went and started a movement, leave 'em confused man that is an awful surprise<br/>
                B&#1077;te tu dete r&#1077;h subs dunga nai fuck kisika bhi khauf hi nai bhai<br/>
                Khabar hai mujhe they faking right to my face man I see through all of your lies<br/>
                Malum hai mujhe you're dissing me<br/>
                Chaiye publicity<br/>
                I know you're sick of me<br/>
                Attention milti nai<br/>
                Sambhaal le bitch apni kar rahi wo simp for me<br/>
                Back when I woke up and had an Epiphany<br/>
                <br/>
                Spazzing all over the show and they're missing me<br/>
                Wo chahe rokne ko mujhe literally<br/>
                I keep on going and go and make history<br/>
                I'm getting low on these hoes and officially<br/>
                <br/>
                Ain't nobody getting ahead of me kabhi nai pakde flow<br/>
                I'mma dead 'em Kennedy sar pe chadke blow<br/>
                Ain't no negative energy, jalke marne do<br/>
                Gotta better my melodies bajne lage hai songs<br/>
                I'mma tell 'em the remedy, sab mujhe bolte G.O.A.T<br/>
                Take Care of my legacy, nobody fucking me over<br/>
                I'm scaring my enemies darte mere opponents<br/>
                <br/>
                And no, the show ain't over<br/>
                XIX<br/>
                BITCH
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default XIXFreeverse;
